<template>
  <div class="signup">
    <div class="container" :class="{'mt-5': !isEdit}">
      <h2 class="title text-center pt-3" v-if="!isEdit">{{$t("message.member_info")}}</h2>
      <h3 v-if='topError' class="error text-center" style="font-size: 1.3rem;"> {{ $t("message.create_profile_error") }} </h3>
      <p class="text-center mb-0 pt-2">
        <b-icon class="h3 mb-0" @click='showInfoModal("message.title_help", "message.step3_title_help")' icon="question-circle"></b-icon>
      </p>
      <validation-observer class="form" ref="obs" >

        <div class="row" :class="{'mt-5': !isEdit}">
          <div class="col-12 mx-auto">
            <label ><span class='pr-2'>★</span>{{$t("message.first_name")}}</label>
            <validation-provider name="first_name" rules="required">
              <div slot-scope="FirstNameProps">
                <input class="simple-input p-2 width100" v-model="member_info.first_name" placeholder="ex）Linh" >
                <p v-if="FirstNameProps.failed" class="error">{{ FirstNameProps.errors[0] }}</p>
              </div>
            </validation-provider>
            <label class="text-gray">{{$t("message.name_validate_message")}} </label>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label >{{$t("message.midle_name")}}</label>
            <validation-provider name="midle_name" >
              <div>
                <input class="simple-input p-2 width100" v-model="member_info.sur_name" placeholder="ex）văn">
              </div>
            </validation-provider>
            <label class="text-gray">{{$t("message.name_validate_message")}} </label>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><span class='pr-2'>★</span>{{$t("message.family_name")}}</label>
            <validation-provider name="family_name" rules="required">
              <div slot-scope="FamilyNameProps">
                <input class="simple-input p-2 width100" v-model="member_info.last_name" placeholder="ex）Nguyễn">
                <p v-if="FamilyNameProps.failed" class="error">{{ FamilyNameProps.errors[0] }}</p>
              </div>
            </validation-provider>
            <label class="text-gray">{{$t("message.name_validate_message")}} </label>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><span class='pr-2'>★</span>{{$t("message.gender")}}</label>
            <validation-provider name="lineId" rules="required" >
              <div slot-scope="LineIdProps">
                <b-form-group >
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="member_info.gender"
                    class='aeru-radio'
                    :options="gender_options"
                    name="radio-options"
                  ></b-form-radio-group>
                </b-form-group>
                <hr class="border"/>
                <p v-if="LineIdProps.failed" class="error">{{ LineIdProps.errors[0] }}</p>
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4" v-if="isEdit != true">
          <div class="col-12 mx-auto" v-if='email == null'>
            <label ><span class='pr-2'>★</span>{{$t("message.mail_adress")}}</label>
            <validation-provider name="email" rules="required|email" >
              <div slot-scope="EmailProps">
                <input class="simple-input p-2 width100" v-model="member_info.email" placeholder="ex）example@example.com">
                <p v-if="EmailProps.failed" class="error">{{ EmailProps.errors[0] }}</p>
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label>Facebook ID</label>
            <validation-provider name="lineId">
              <div slot-scope="LineIdProps">
                <input class="simple-input p-2 width100" v-model="member_info.facebook_id" placeholder="ex）https://www.facebook.com/aelu.aelu">
                <p v-if="LineIdProps.failed" class="error">{{ LineIdProps.errors[0] }}</p>
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.country_input_help")' icon="question-circle"></b-icon>{{$t("message.country_id")}}</label>
            <validation-provider name="country_id">
              <v-select class="simple-v-select" label="text" :reduce="data => data.value" :options="country_id_list" v-model="member_info.nationality"></v-select>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.area_input_help")' icon="question-circle"></b-icon><span class='pr-2'>★</span>{{$t("message.live_at_area")}}</label>
            <validation-provider name="live_at_area" rules="required" >
              <v-select class="simple-v-select" label="text" :reduce="data => data.value" :options="country_id_list" v-model="member_info.live_area"></v-select>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4" v-if='member_info.live_area == "日本"'>
          <div class="col-12 mx-auto">
            <label ><span class='pr-2'>★</span>{{$t("message.prefectures")}}</label>
            <validation-provider name="live_at_area" >
              <div>
                <div class="aeru-select-wrap">
                  <b-form-select class="aeru-select" v-model="member_info.region" :options="prefectures_list"></b-form-select>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.phone_input_help")' icon="question-circle"></b-icon><span class='pr-2'>★</span>{{$t("message.phone")}}</label>
            <validation-provider name="phone" rules="required|phone">
              <div slot-scope="PhoneProps">
                <input type ="tel" class="simple-input p-2 width100" v-model="member_info.phone" placeholder="ex）08000000000">
                <p v-if="PhoneProps.failed" class="error">{{ PhoneProps.errors[0] }}</p>
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.issuing_input_help")' icon="question-circle"></b-icon><span class='pr-2'>★</span>{{$t("message.issuing_country")}}</label>
            <validation-provider name="issuing_country">
              <div slot-scope="IssuingProps">
                <v-select class="simple-v-select" label="text" :reduce="data => data.value" :options="country_id_list" v-model="member_info.issuing_country"></v-select>
                <p v-if="IssuingProps.failed" class="error">{{ IssuingProps.errors[0] }}</p>
              </div>
            </validation-provider>
          </div>
        </div>

        <div v-if="member_info.partner_id == '' || member_info.partner_id == null" class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.invitation_input_help")' icon="question-circle"></b-icon>{{$t("message.invitation_code")}}{{$t("message.invitation_code_description")}}</label>
            <input class="simple-input p-2 width100" v-model="invitation_code">
          </div>
        </div>

        <div class="row mt-4 pt-4">
          <div class="col-12 mx-auto">
            <label ><b-icon class="h4 mr-2 mb-0" @click='showInfoModal("message.title_help", "message.idtype_input_help")' icon="question-circle"></b-icon><span class='pr-2'>★</span>{{$t("message.IDtype")}}</label>
            <validation-provider name="idtype" rules="required" >
              <div slot-scope="IdTypeProps">
                <v-select class="simple-v-select" label="text" :reduce="data => data.value" :options="idTypeList" v-model="member_info.id_type"></v-select>

                <b-form-group v-if='member_info.id_type == "residence"'>
                  <div class="row mt-4">
                    <div class="col-12 col-lg-12">
                        <p>{{$t("message.resident_caption_title")}}</p>
                        <p>{{$t("message.resident_caption")}}</p>
                    </div>
                    <div class="col-12 col-lg-6 px-0 pt-2">
                      <div class="row">
                        <div class="col-12 col-lg-12 px-3 pt-4 pb-2 text-center">
                          <!-- <b-img class="w100" src='../../../assets/createuser/resident_c_f.png'></b-img> -->
                        </div>
                        <div class="col-1 col-lg-1"></div>
                        <div class="col-2 col-lg-2 px-2">
                          <b-img src='../../../assets/createuser/resident_card_front.png'></b-img>
                        </div>
                        <div class="col-8 col-lg-8 mx-0">
                          <div v-if='image_names.residence_front == "" || image_names.residence_front.match(/pdf/g) == null'>
                            <label class="file-input-label width100 ">
                              Surface Upload
                              <input v-if="!isImage1" id="residence_front" class='file-input' type="file" name="img" @change="uploadFile($event, 'residence_front')">
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 ml-3">
                          <div v-if="id_images[0] != null">
                            <img class="img-c isImage" :src="id_images[0]"/>
                          </div>
                          <div v-if='!(image_names.residence_front == "" || image_names.residence_front.match(/pdf/g) == null)'>
                            <a target="_blank" :href="image_pdfs.residence_front">{{image_names.residence_front}} </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-lg-6 px-0 pt-4">
                      <div class="row">
                        <div class="col-12 col-lg-12 px-3 pt-2 pb-2 text-center">
                          <!-- <b-img class="w100" src='../../../assets/createuser/resident_c_b.png'></b-img> -->
                        </div>
                        <div class="col-1 col-lg-1"></div>
                        <div class="col-2 col-lg-2 px-2">
                          <b-img src='../../../assets/createuser/resident_card_back.png'></b-img>
                        </div>
                        <div class="col-8 col-lg-8 mx-0">
                          <div v-if='image_names.residence_back == "" || image_names.residence_back.match(/pdf/g) == null'>
                            <label class="file-input-label width100 ">
                              Upload on the back
                              <input v-if="!isImage2" id="residence_back" class='file-input' type="file" name="img" @change="uploadFile($event, 'residence_back')">
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 ml-3">
                          <div v-if="id_images[1] != null">
                            <img class="img-c isImage" :src="id_images[1]"/>
                          </div>
                          <div v-if='!(image_names.residence_back == "" || image_names.residence_back.match(/pdf/g) == null)'>
                            <a target="_blank" :href="image_pdfs.residence_back">{{image_names.residence_back}} </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="IdTypeProps.failed" class="error">{{ IdTypeProps.errors[0] }}</p>
                  <p v-if="fileValid" class="error">{{$t("message.error_file")}}</p>
                </b-form-group>

                <b-form-group v-else-if='member_info.id_type == "id"'>
                  <div class="row mt-4">
                    <div class="col-12 px-2">
                      <div class="row">
                        <div class="col-12 col-lg-6 px-4">
                          <p>{{$t("message.password_caption_title")}}</p>
                          <p>{{$t("message.password_caption")}}</p>

                          <div v-if='image_names.residence_front == "" || image_names.residence_front.match(/pdf/g) == null'>
                            <b-img src='../../../assets/createuser/passport.png' width='30' height='40'></b-img>
                            <label class="file-input-label w80 ml-2 ">
                              Upload your passport
                              <input id="passport" class='file-input' type="file" name="img" @change="uploadFile($event, 'passport')">
                            </label>
                          </div>
                        </div>
                        <div class="col-12 col-lg-6 pt-3 text-center">
                            <!-- <b-img class="w80" src='../../../assets/createuser/pass.png' ></b-img> -->
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 ml-3">
                          <div v-if='image_names.passport == "" || image_names.passport.match(/pdf/g) == null'>
                            <div :key="i" v-for="i in id_images">
                              <img class="img-c isImage" :src="i"/>
                            </div>
                          </div>
                          <div v-else>
                            <a target="_blank" :href="image_pdfs.passport">{{image_names.passport}} </a>
                          </div>
                          <label>{{$t("message.reselect")}}</label>
                          <label>{{$t("message.iphone_file")}} <a href="https://convertio.co/ja/heic-jpg/">{{$t("message.file_transmit")}}</a></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="IdTypeProps.failed" class="error">{{ IdTypeProps.errors[0] }}</p>
                  <p v-if="fileValid" class="error">{{$t("message.error_file")}}</p>
                </b-form-group>
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4 pt-4" v-if='this.$route.path == "/profile_setting"'>
          <div class="col-12 mx-auto">
            <label >{{$t("message.post_resume")}}</label>
            <validation-provider name="resume" >
              <div slot-scope="RerumeProps">
                <div v-if='resume_name == "" || resume_name.match(/pdf/g) == null'>
                  {{$t("message.resume_upload")}}
                  <div id="upload" v-if="user_resume == null" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB , 'isImage':isResume}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadResume($event) " :style="{background: 'url(' + resume_image + ')'}">
                    <label for="resume" class="button" >
                      <p v-if='!isResume' >＋</p>
                      <input id="resume" type="file" name="img" @change="uploadResume($event)" style="display:none;" accept="image/*,application/pdf">
                    </label>

                    <p v-if='!isResume' >{{$t("message.click_upload")}}</p>
                    <p v-if='!isResume'>{{$t("message.image_drop")}}</p>

                  </div>
                  <div v-else>
                    <img class="img-c isImage" :src="memberInfo.resume_image_url"/>
                  </div>
                  <p v-if="RerumeProps.failed" class="error">{{ RerumeProps.errors[0] }}</p>
                </div>
                <div v-else>
                  {{$t("message.resume_upload")}}<br>
                  <a target="_blank" :href="pdf_url">{{resume_name}} </a>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="row mt-5 mb-5">
          <div class="col-6 col-lg-6 text-right">
            <b-button
              type="button"
              class="mx-1 my-2 btn rounded-circle gray-button-fill"
              style="width:4rem;height:4rem;"
              @click='changeMode("language")'
            >
              back
            </b-button>
          </div>

          <div class="col-6 col-lg-6 text-left">
            <b-button
              type="button"
              class="mx-1 my-2 btn rounded-circle blue-button"
              style="width:4rem;height:4rem;"
              @click='regist_member("confirm")'
            >
              next
            </b-button>
          </div>
        </div>
      </validation-observer>
    </div>
    <info-modal ref="info"></info-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import { mapState } from 'vuex';
import InfoModal from "@/components/InfoModal"
import axios from 'axios';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    InfoModal
  },
  data () {
    return {
      member_info:{
        first_name: '',
        sur_name: "",
        last_name: "",
        line_id: "",
        nationality: "日本",
        email: "",
        phone: "",
        issuing_country: "日本",
        id_type: null,
        facebook_id: '',
        live_area: "" ,
        region: ''
      },
      isImage1: false,
      isImage2: false,
      isResume: false,
      isEdit: false,
      id_images: [],
      resume_images: [],
      user_resume:null,
      invitation_code: '',
      images: {
        residence_front: "",
        residence_back: "",
        passport: "",
      },
      resume_image: "",
      idTypeList: [
        { value: 'residence', text: this.$i18n.t('message.residence_card')},
        { value: 'id', text: this.$i18n.t('message.passport')}
      ],
      country_id_list: [
        { value: 'ベトナム', text: this.$i18n.t('message.vietnum') },
        { value: 'ラオス', text: this.$i18n.t('message.laos') },
        { value: 'マレーシア', text: this.$i18n.t('message.malaysia') },
        { value: 'バングラデッシュ', text: this.$i18n.t('message.bangladesh') },
        { value: 'インド', text: this.$i18n.t('message.indo') },
        { value: 'モンゴル', text: this.$i18n.t('message.mongol') },
        { value: 'ネパール', text: this.$i18n.t('message.nepal') },
        { value: 'インドネシア', text: this.$i18n.t('message.indonesia') },
        { value: 'タイ', text: this.$i18n.t('message.th') },
        { value: 'フィリピン', text: this.$i18n.t('message.philipine') },
        { value: 'ミャンマー', text: this.$i18n.t('message.my') },
        { value: 'ウズベキスタン', text: this.$i18n.t('message.uzbekistan') },
        { value: 'パキスタン', text: this.$i18n.t('message.pakistan') },
        { value: '日本', text: this.$i18n.t('message.japan') },
        { value: 'スリランカ', text: this.$i18n.t('message.srilank') },
        { value: 'カンボジア', text: this.$i18n.t('message.combodia') },
      ],
      prefectures_list: [
        { value: 'Hokkaido', text: this.$i18n.t('message.hokkaido')},
        { value: 'Aomori', text: this.$i18n.t('message.aomori')},
        { value: 'Iwate', text: this.$i18n.t('message.iwate')},
        { value: 'Miyagi', text: this.$i18n.t('message.miyagi')},
        { value: 'Akita', text: this.$i18n.t('message.akita')},
        { value: 'Yamagata', text: this.$i18n.t('message.yamagata')},
        { value: 'Fukushima', text: this.$i18n.t('message.fukushima')},
        { value: 'Ibaraki', text: this.$i18n.t('message.ibaraki')},
        { value: 'Tochigi', text: this.$i18n.t('message.tochigi')},
        { value: 'Gunma', text: this.$i18n.t('message.gunma')},
        { value: 'Saitama', text: this.$i18n.t('message.saitama')},
        { value: 'Chiba', text: this.$i18n.t('message.chiba')},
        { value: 'Tokyo', text: this.$i18n.t('message.tokyo')},
        { value: 'Kanagawa', text: this.$i18n.t('message.kanagawa')},
        { value: 'Niigata', text: this.$i18n.t('message.niigata')},
        { value: 'Toyama', text: this.$i18n.t('message.toyama')},
        { value: 'Ishikawa', text: this.$i18n.t('message.ishikawa')},
        { value: 'Fukui', text: this.$i18n.t('message.fukui')},
        { value: 'Yamanashi', text: this.$i18n.t('message.yamanashi')},
        { value: 'Nagano', text: this.$i18n.t('message.nagano')},
        { value: 'Gifu', text: this.$i18n.t('message.gifu')},
        { value: 'Shizuoka', text: this.$i18n.t('message.shizuoka')},
        { value: 'Aichi', text: this.$i18n.t('message.aichi')},
        { value: 'Mie', text: this.$i18n.t('message.mie')},
        { value: 'Shiga', text: this.$i18n.t('message.shiga')},
        { value: 'Kyoto', text: this.$i18n.t('message.kyoto')},
        { value: 'Osaka', text: this.$i18n.t('message.osaka')},
        { value: 'Hyogo', text: this.$i18n.t('message.hyogo')},
        { value: 'Nara', text: this.$i18n.t('message.nara')},
        { value: 'Wakayama', text: this.$i18n.t('message.wakayama')},
        { value: 'Tottori', text: this.$i18n.t('message.tottori')},
        { value: 'Shimane', text: this.$i18n.t('message.shimane')},
        { value: 'Okayama', text: this.$i18n.t('message.okayama')},
        { value: 'Hiroshima', text: this.$i18n.t('message.hiroshima')},
        { value: 'Yamaguchi', text: this.$i18n.t('message.yamaguti')},
        { value: 'Tokushima', text: this.$i18n.t('message.tokushima')},
        { value: 'Kagawa', text: this.$i18n.t('message.kagawa')},
        { value: 'Ehime', text: this.$i18n.t('message.ehime')},
        { value: 'Kochi', text: this.$i18n.t('message.kochi')},
        { value: 'Fukuoka', text: this.$i18n.t('message.fukuoka')},
        { value: 'Saga', text: this.$i18n.t('message.saga')},
        { value: 'Nagasaki', text: this.$i18n.t('message.nagasaki')},
        { value: 'Kumamoto', text: this.$i18n.t('message.kumamoto')},
        { value: 'Oita', text: this.$i18n.t('message.oita')},
        { value: 'Miyazaki', text: this.$i18n.t('message.miyazaki')},
        { value: 'Kagoshima', text: this.$i18n.t('message.kagoshima')},
        { value: 'Okinawa', text: this.$i18n.t('message.okinawa')}
      ],
      options: [
        { value: 'ja', text: 'japan' },
        { value: 'en', text: '' },
        { value: 'ban', text: 'BANGLADESH'},
        { value: 'bur', text: 'MYANMER' },
        { value: 'hin', text: 'INDHI' },
        { value: 'ind', text: 'INDONESIAN' },
        { value: 'kh', text: 'CAMBODIA' },
        { value: 'lao', text: 'laos' },
        { value: 'mon', text: 'MONGOLIA' },
        { value: 'ne', text: 'NEPAL' },
        { value: 'taga', text: 'PHILIPIN' },
        { value: 'thai', text: 'THAI' },
        { value: 'vietnum', text: 'vietnum' },
        { value: 'malaysia', text: 'malaysia' },
        { value: 'combodia', text: 'combodia' },
      ],
      l_list: {
        'vi': "vietnamese",
        'ch': "chinese",
        'en': "english",
        'kh': "khmer",
        'ind': "indonesian",
        'taga': "tagalog",
        'bur': "myanmar",
        'hin': "hindu",
        'lao': "lao",
        'mon': "mongolian",
        'ban': "bengali",
        'ja': "japanese",
        "sinhala": ''
      },
      styleA:true,
      styleB:false,
      fileValid: false,
      topError: false,
      idToken: localStorage.idToken,
      locate: this.$i18n.locale,
      resume_name: '',
      image_names: {
        residence_front: "",
        residence_back: "",
        passport: "",
      },
      image_pdfs: {
        residence_front: "",
        residence_back: "",
        passport: "",
      },
      //isFacebookApp: false,
      pdf_url: '',
      gender_options: [
          { text: this.$i18n.t('message.man'), value: 'man' },
          { text: this.$i18n.t('message.woman'), value: 'women' }
        ]
    }
  },
  methods: {
    changeMode(mode){
      this.$emit('next', {mode: mode});
    },
    showInfoModal(title='message.sample_title', description='message.sample_description'){
      this.$refs.info.showModal(this.$i18n.t(title), this.$i18n.t(description))
    },
    uploadFile: function(event, type){
      this.styleA = true;
      this.styleB = false;
      const files = event.target.files ? event.target.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
        if (type == "residence_front") {
          this.isImage1 = true
          this.images.residence_front = event.target.result;
          this.id_images.push(event.target.result)
        } else{
          if (type == "residence_back") {
            this.isImage2 = true
            this.images.residence_back = event.target.result;
            this.id_images.push(event.target.result)
          } else {
            this.isImage1 = false
            this.isImage2 = false
            this.id_images = []
            this.images.passport = event.target.result;
            this.id_images.push(event.target.result)
          }
        }
      };
      if (type == "residence_front") {
        this.image_names.residence_front = file.name;
        if(this.image_names.residence_front.match(/pdf/g) == null){
          reader.readAsDataURL(file);
        }else{
          this.image_pdfs.residence_front = URL.createObjectURL(file)
        }
      } else {
        if (type == "residence_back") {
          this.image_names.residence_back = file.name;
          if(this.image_names.residence_back.match(/pdf/g) == null){
            reader.readAsDataURL(file);
          }else{
            this.image_pdfs.residence_back = URL.createObjectURL(file)
          }
        } else {
          this.image_names.passport = file.name;
          if(this.image_names.passport.match(/pdf/g) == null){
            reader.readAsDataURL(file);
          }else{
            this.image_pdfs.passport = URL.createObjectURL(file)
          }
        }
      }
      // reader.readAsDataURL(file);
      document.getElementById(type).files = files;
    },
    uploadResume: function(event){
      this.styleA = true;
      this.styleB = false;
      const files = event.target.files ? event.target.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
          this.isResume = true
          this.resume_image = event.target.result;
          this.resume_images.push(event.target.result)
      };
      this.resume_name = file.name;

      if(this.resume_name.match(/pdf/g) == null){
        reader.readAsDataURL(file);
      }else{
        this.pdf_url = URL.createObjectURL(file)
      }

      document.getElementById('resume').files = files;

    },
    changeStyle: function(event,flag){
        if(flag=='ok'){
            this.styleA = false;
            this.styleB = true;
        }else{
            this.styleA = true;
            this.styleB = false;
        }
    },
    async regist_member(mode){
      return this.$refs.obs.validate().then(value =>{
        if(value){
          if(this.member_info.id_type == "id") { 
            if(this.id_images.length == 0) {
              return alert("在留カード or IDカードの写真を添付してください")
            }
          } else {
            if(this.id_images.length == 0) {
              return alert("パスポートの写真を添付してください")
            }
          }
          this.member_info['sub'] = this.user.sub
          this.member_info["language"] = this.l_list[this.language]
          this.member_info["current_industry"] = this.memberInfo.current_industry
          this.member_info["interested_industry"] = this.memberInfo.interested_industry
          this.member_info["industry_id"] = this.memberInfo.industry_id
          var regist = {}
          this.$store.commit('setLoading', true)

          if(this.member_info.id_type == 'residence'){
            if(this.images.residence_front == "" || this.images.residence_back == ""){
              this.fileValid = true
              return false
            } else{
              if(this.resume_image == ''){
                regist = {user: this.member_info, id_images: this.id_images, invitation_code:this.invitation_code}
              }else{
                regist = {user: this.member_info, id_images: this.id_images , resume_image: this.resume_image, invitation_code:this.invitation_code}
              }
              this.fileValid = false
              axios
                .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
                .then(response => {
                  this.$store.commit('setLoading', false)
                  this.$store.commit('user/setUser', response.data)
                  this.$emit('next', {mode: mode, data: regist});
                }).catch(error => {
                  console.log('this is error', error)
                })
              return true
            }
          } else if(this.member_info.id_type == 'id') {
            if(this.images.passport == "") {
              this.fileValid = true
              return false
            } else {
              if(this.resume_image == ''){
                regist = {user: this.member_info, id_images: this.id_images, invitation_code:this.invitation_code}
              }else{
                regist = {user: this.member_info, id_images: this.id_images , resume_image: this.resume_image, invitation_code:this.invitation_code}
              }
              this.fileValid = false
              axios
                .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
                .then(response => {
                  this.$store.commit('setLoading', false)
                  this.$store.commit('user/setUser', response.data)
                  this.$emit('next', {mode: mode, data: regist});
                }).catch(() => {
                })
            }
          } else {
            if(this.resume_image == ""){
              this.fileValid = true
              return false
            }else{
              if(this.resume_image == ''){
                regist = {user: this.member_info, id_images: this.id_images, invitation_code:this.invitation_code}
              }else{
                regist = {user: this.member_info, id_images: this.id_images , resume_image: this.resume_image, invitation_code:this.invitation_code}
              }
              this.fileValid = false
              axios
                .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
                .then(response => {
                  this.$store.commit('setLoading', false)
                  this.$store.commit('user/setUser', response.data)
                  this.$emit('next', {mode: mode, data: regist});
                }).catch(() => {
                })
            }
          }
        }
        else{
          this.topError = true
          this.$store.commit('setLoading', false)
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          console.log(value)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    refleshLang: function() {
      this.country_id_list = [
        { value: 'ベトナム', text: this.$i18n.t('message.vietnum') },
        { value: 'ラオス', text: this.$i18n.t('message.laos') },
        { value: 'マレーシア', text: this.$i18n.t('message.malaysia') },
        { value: 'バングラデッシュ', text: this.$i18n.t('message.bangladesh') },
        { value: 'インド', text: this.$i18n.t('message.indo') },
        { value: 'モンゴル', text: this.$i18n.t('message.mongol') },
        { value: 'ネパール', text: this.$i18n.t('message.nepal') },
        { value: 'インドネシア', text: this.$i18n.t('message.indonesia') },
        { value: 'タイ', text: this.$i18n.t('message.th') },
        { value: 'フィリピン', text: this.$i18n.t('message.philipine') },
        { value: 'ミャンマー', text: this.$i18n.t('message.my') },
        { value: 'ウズベキスタン', text: this.$i18n.t('message.uzbekistan') },
        { value: 'パキスタン', text: this.$i18n.t('message.pakistan') },
        { value: '日本', text: this.$i18n.t('message.japan') },
        { value: 'スリランカ', text: this.$i18n.t('message.srilank') },
        { value: 'カンボジア', text: this.$i18n.t('message.combodia') },
      ]

      this.gender_options = [
          { text: this.$i18n.t('message.man'), value: 'man' },
          { text: this.$i18n.t('message.woman'), value: 'women' }
        ]

    },
    acceptType: function() {
      if(this.isFacebookApp) {
        console.log("sampl")
      } else {
        return "image/*,application/pdf"
      }
    }

  },

  computed: {
    ...mapState({
        user: state => state.user.user,
        email: state => state.user.email,
        memberInfo: state => state.user.user,
        outh: state => state.user.outh,
        language: state => state.language,
        cache: state => state.user.cache,
    })
  },
  mounted(){
    this.member_info.email = this.email
    this.member_info = Object.assign({}, this.member_info)
    if(this.cache.user != undefined){
      this.member_info = this.cache.user
      this.id_images = this.cache.id_images
    }

    if(this.$route.path == "/profile_setting"){
      this.isEdit = true
      this.member_info = Object.assign({}, this.memberInfo)
      this.user_resume = this.memberInfo.resume_image_url
      this.id_images = this.memberInfo.id_image_urls.split(",")

      if(this.member_info.id_type == "id") {
        this.image_names.passport = this.id_images[0]
        this.images.passport = this.id_images[0]
        this.image_names.residence_front = ""
        this.image_names.residence_back = ""
        this.images.residence_front = ""
        this.images.residence_back = ""
      } else {
        this.image_names.passport = ""
        this.images.passport = ""
        this.image_names.residence_front = this.id_images[0]
        this.image_names.residence_back = this.id_images[1]
        this.images.residence_front = this.id_images[0]
        this.images.residence_back = this.id_images[1]
      }

      this.$i18n.locale = this.LANGUAGE_LIST[this.member_info.language]
      this.$store.commit('setLanguage', this.LANGUAGE_LIST[this.member_info.language])
      this.refleshLang()
    }else{
      if(this.outh.username.match("Google") || this.outh.username.match("Facebook")){
        this.member_info.email = this.outh.attributes.email
        this.member_info = Object.assign({}, this.memberInfo)
        if(this.outh.username.match("Facebook")){
          this.member_info.facebook_id = this.outh.username.split('_')[1]
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">
.dirty {
    border-color: #F5F5F8;
    background: #F5F5F8;
    width: 100%;
}
input::placeholder{
  font-size: 16px;
  line-height: 24px;
  color: rgba(1, 1, 20, 0.26);
}

.commonStyle{
  padding: 2rem;
  text-align:center;
}
.styleA{
  border:3px dotted gray;
  background-color: #F5F5F8 !important;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}
.styleB{
  border:3px dotted rgba(0,200,0,0.7);
}
.button{
  border:0px solid black;
  padding:3px;
  border-radius:5px;
  background-color: none;
}
.button p {
  color:black;
  font-size: 20px;
  margin-top:10px;
  margin-left:10px;
  margin-right: 10px;
}
.isImage{
  min-height: 350px;
  background-position: center !important;
}
.img-c {
  max-width: 100%;
}
label {
  margin-bottom: 0px;
  span {
    color: #F39147;
  }
}
.w100 {
  width: 90%;
}
.w80 {
  width: 80%;
}
h4 {
  font-size: 20px;
}
</style>
